import HttpRequest from './HttpRequest';

export const getWoodenFish = async () => {
  try {
    const response = await HttpRequest.get('/woodenfish');
    return response;
  } catch (err) {
    console.error(err);
    return null;
  }
};
